import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { normalizeHref } from '../../plugins/LinkPlugin/utils';
import {
  getEmbedResizableAttributes,
  isHTMLElementNode,
} from '../helpers/serializerHelpers';
import { type EmbedElement } from '../../types/aha-editor';
import { isEmbedElement } from '../../types/guards';

class SerializerEmbed extends Serializer {
  static deserialize({
    el,
    next,
    markAttributes,
  }: DeserializeArguments): EmbedElement | undefined {
    if (
      !isHTMLElementNode(el) ||
      el.tagName.toLowerCase() !== 'a' ||
      !el.hasAttribute('data-embed-src')
    ) {
      return;
    }

    const src = el.getAttribute('data-embed-src');

    const data: Omit<EmbedElement, 'type' | 'children'> = {
      embed_src: src ?? '',
    };

    if (el.getAttribute('data-embed-display') === 'link') {
      data.embed_display = 'link';
    }

    return {
      type: 'embed',
      children: [{ text: '' }],
      ...data,
      ...getEmbedResizableAttributes(el),
    };
  }

  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isEmbedElement(node)) return;

    const {
      resizer_width,
      resizer_height,
      resizer_originalWidth,
      resizer_originalHeight,
      embed_src,
      embed_display,
    } = node;

    return (
      <a
        href={normalizeHref(embed_src)}
        data-embed-src={embed_src}
        data-embed-display={
          embed_display === 'frame' ? undefined : embed_display
        }
        data-width={resizer_width}
        data-height={resizer_height}
        data-original-width={resizer_originalWidth}
        data-original-height={resizer_originalHeight}
      >
        {embed_src}
      </a>
    );
  }
}

export default SerializerEmbed;
